'use strict';

import React from 'react';
import { Route, NotFoundRoute, DefaultRoute } from 'react-router';
import flux from 'utils/flux';

import App from 'pages/app';
import NotFoundPage from 'pages/notFound';
import RedirectPage from 'pages/redirect';
import LoginPage from 'pages/login/loginIndex';
import AcceptTermsPage from 'pages/acceptTerms/termsIndex';

import ResetPasswordPage from 'pages/resetPassword';
import ConfirmEmailPage from 'pages/confirmEmail';

import ListingPage from 'pages/media';
import MediaListingPage from 'pages/media/mediaListing';

import BasketPage from 'pages/basket';
import LicensingPage from 'pages/licensing/listing';
import RequestsPage from 'pages/licensing/requests';
import SharePage from 'pages/share';

import AccountPage from 'pages/account';
import AccountEditPage from 'pages/account/accountEdit';
import AccountPasswordPage from 'pages/account/accountPassword';

import HelpPage from 'pages/help';
import TermsPage from 'pages/terms';

const appStore = flux.getStore('app');
const { config } = appStore.getState();
const { accountEditable, passwordEditable } = appStore;

var routes = (
    <Route handler={App}>
        <Route name="login" path="login" handler={LoginPage} />
        <Route name="accept_terms" path="accept_terms" handler={AcceptTermsPage} />
        <Route name="reset_password" path="reset_password/:secret" handler={ResetPasswordPage} />
        <Route name="confirm_email" path="confirm_email" handler={ConfirmEmailPage} />

        <Route name="listing" path="media" handler={ListingPage}>
            <DefaultRoute handler={MediaListingPage} />
        </Route>

        <Route name="basket" path="baskets" handler={BasketPage}>
            <Route name="singleBasket" path=":id" handler={BasketPage} />
        </Route>

        <Route name="shared" path="shared/:shareId/:basketId" handler={SharePage} />

        {
            config.get('licensing') &&
            <Route name="licensing" path="licensing" handler={LicensingPage}>
                <Route name="singleLicensing" path=":id" handler={LicensingPage} />
            </Route>
        }
        {config.get('licensing') && <Route name="requests" path="requests" handler={RequestsPage} />}

        <Route name="account" path="account" handler={AccountPage}>
            {false !== accountEditable && <Route name="accountDetails" path="details" handler={AccountEditPage} />}
            {false !== passwordEditable && <Route name="accountPassword" path="password" handler={AccountPasswordPage} />}
            <DefaultRoute handler={false !== accountEditable ? AccountEditPage : AccountPage} />
        </Route>

        <Route name="help" path="help" handler={HelpPage} />
        <Route name="terms" path="terms-of-use" handler={TermsPage} />

        <NotFoundRoute handler={NotFoundPage}/>
        <DefaultRoute handler={RedirectPage} />
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./app/routes.jsx